interface Props {
    className?: string;
}

export function InfoCircleOutlineIcon({ className }: Props) {
    return (
        <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" fill="none">
            <path
                d="M6 0.75C3.10078 0.75 0.75 3.10078 0.75 6C0.75 8.89922 3.10078 11.25 6 11.25C8.89922 11.25 11.25 8.89922 11.25 6C11.25 3.10078 8.89922 0.75 6 0.75ZM6 10.3594C3.59297 10.3594 1.64062 8.40703 1.64062 6C1.64062 3.59297 3.59297 1.64062 6 1.64062C8.40703 1.64062 10.3594 3.59297 10.3594 6C10.3594 8.40703 8.40703 10.3594 6 10.3594Z"
                fill="currentColor"
            />
            <path
                d="M5.4375 3.9375C5.4375 4.08668 5.49676 4.22976 5.60225 4.33525C5.70774 4.44074 5.85082 4.5 6 4.5C6.14918 4.5 6.29226 4.44074 6.39775 4.33525C6.50324 4.22976 6.5625 4.08668 6.5625 3.9375C6.5625 3.78832 6.50324 3.64524 6.39775 3.53975C6.29226 3.43426 6.14918 3.375 6 3.375C5.85082 3.375 5.70774 3.43426 5.60225 3.53975C5.49676 3.64524 5.4375 3.78832 5.4375 3.9375ZM6.28125 5.25H5.71875C5.66719 5.25 5.625 5.29219 5.625 5.34375V8.53125C5.625 8.58281 5.66719 8.625 5.71875 8.625H6.28125C6.33281 8.625 6.375 8.58281 6.375 8.53125V5.34375C6.375 5.29219 6.33281 5.25 6.28125 5.25Z"
                fill="currentColor"
            />
        </svg>
    );
}
